<template>
   <div class="biddEd">
        <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
                <span slot="applyUrl" slot-scope="text,record">
                  <el-image :src="text" style="width:80px;height:60px;" :preview-src-list="record.applyUrlList"></el-image>
                </span>
                <span slot="biddingPrice" slot-scope="text">{{ text }}万元</span>
                <span slot="biddingUp" slot-scope="text">{{ text }}元</span>
                <span slot="biddingCode" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <span slot="projectCode" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <template slot="action" slot-scope="text,record">
                    <div class="operate-btns">
                        <a-upload class="upload-demo"
                            :disabled="record.applyState=='2'?false:true"
                            action="#" :customRequest="customRequest" :show-upload-list="false"
                            @click.native = getRow(record)
                            >
                          <a-button type="primary" :disabled="record.applyState=='2'?false:true">上传支付凭证</a-button>
                      </a-upload>
                    </div>
                </template>
            </a-table>
        </div>    
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination> 
   </div>    
</template>

<script>
const columns = [
    {
      title: '竞拍编号',
      dataIndex: 'biddingCode',
      width:100,
      scopedSlots: { customRender: 'biddingCode' },
      ellipsis: true,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      width:100,
      scopedSlots: { customRender: 'projectName' },
      ellipsis: true,
    },
    {
      title: '项目编码',
      dataIndex: 'projectCode',
      width:100,
      scopedSlots: { customRender: 'projectCode' },
      ellipsis: true,
    },
    {
      title: '项目状态',
      dataIndex: 'biddingStateName',
      width:100,
      scopedSlots: { customRender: 'biddingStateName' },
      ellipsis: true,
    },
    {
      title: '起拍价',
      dataIndex: 'biddingPrice',
      width:100,
      scopedSlots: { customRender: 'biddingPrice' },
      ellipsis: true,
    },
    {
      title: '加价幅度',
      dataIndex: 'biddingUp',
      width:100,
      scopedSlots: { customRender: 'biddingUp' },
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'applyStateName',
      width:100,
      scopedSlots: { customRender: 'applyStateName' },
      ellipsis: true,
    },
    {
      title: '支付凭证',
      dataIndex: 'applyUrl',
      width:120,
      scopedSlots: { customRender: 'applyUrl' },
    },
    {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 220,
      scopedSlots: { customRender: 'action' },
    },
]    
export default {
    data(){
        return{
            columns:columns,
            loading:false,
            data:[],
            params:{
                pageSize:10,
                pageNum:1
            },
            total:0,
            currentItem:'',
        }
    },
    created(){
        this.getDataList()
    },
    mounted(){
        this.$parent.activeIndex = 4;
    },
    methods:{
        getDataList(){ 
            this.loading = true;
            this.$https.get('/portal/bidding/getBiddingApplyByUserId').then(res=>{
               this.loading = false;
               if(res.code == 200){
                  res.rows.forEach(item=>{
                   item.applyUrlList = [];
                   item.applyUrlList.push(item.applyUrl)
                 })
                  this.data = res.rows;
                  //判断下单时间是否有30分钟
                  this.total = Number(res.total);
               }
            }).catch(error=>{
                this.loading = false;
            })      
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
         getRow(row){
           this.currentItem = row;
        },
         customRequest(info){
           let formdata=new FormData();
            formdata.append("file",info.file);
            this.$https.post('/file/upload',formdata).then(res=>{
               if(res.code == 200){
                  this.uploadNote(res.data.url)
               }
            }).catch(error=>{
               this.$error({content:'上传失败'});
            })
        },
        uploadNote(url){
            this.$https.post('/portal/bidding/projectBiddingRepeatApply',{applyUrl:url,biddingId:this.currentItem.biddingId,id:this.currentItem.id}).then(res=>{
                   if(res.code == 200){
                      this.$message.success('上传成功');
                      this.form.pageNum=1;
                      this.getDataList();
                   }else{
                     this.$message.error(res.msg)
                   }
            })
        },
    }
}
</script>

<style>

</style>